import React from 'react';
import { useNavigate } from 'react-router';
import { notification } from 'antd';

import { MainLayout } from 'components/Layout/MainLayout';
import { useAppDispatch } from 'store';
import {
  saveInvestmentSolutionsItem,
  saveInvestmentSolutionsItemDraft,
} from 'store/slices/investmentSolutions/actions';
import { InvestmentSolutionsItem } from 'store/slices/investmentSolutions/interfaces';
import { DeepPartial } from 'types/utils';

import { Form } from './components/Form';

export const Add = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onSubmit = (values: InvestmentSolutionsItem) => {
    setIsLoading(true);
    dispatch(saveInvestmentSolutionsItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно добавлена',
        });
        navigate('/investmentSolutions');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveAsDraft = (values: DeepPartial<InvestmentSolutionsItem>) => {
    setIsLoading(true);
    dispatch(saveInvestmentSolutionsItemDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешо создана',
        });
        navigate('/investmentSolutions');
      })
      .catch(() => setIsLoading(false));
  };

  return (
    <MainLayout pageTitle='Создание'>
      <Form
        onSubmit={onSubmit}
        onSaveAsDraft={onSaveAsDraft}
        isDraft
        isLoading={isLoading}
      />
    </MainLayout>
  );
};
